<template>
    <ion-app>
        <ion-loading :is-open="busy" message="Loading, please wait"/>
        <ion-split-pane contentId="main-content" :disabled="hideSideMenus">
            <ion-menu side="start" menuId="navigation" contentId="main-content" type="overlay">
                <ion-content>
                    <ion-list>
                      <ion-list-header>RAF v{{ $version }}</ion-list-header>
                        <ion-menu-toggle auto-hide="false" menu="navigation">
                          <ion-item :detail="true" :disabled="p.disabled" @click="$router.push({name: p.name})" v-for="(p, index) in appPages" :key="`left-nav-${index}`">
                            <ion-label>{{ p.title }}</ion-label>
                          </ion-item>
                        </ion-menu-toggle>
                    </ion-list>
                </ion-content>
            </ion-menu>
            <ion-menu side="end" menuId="settings" contentId="main-content" type="overlay">
                <ion-content>
                    <ion-list>
                        <ion-list-header>User: {{ user?user.name:'Unknown' }}</ion-list-header>
                            <ion-menu-toggle auto-hide="false" v-for="(p, index) in appSettingsPages" :key="`right-nav-${index}`" menu="settings">
                            <ion-item :detail="true" @click="$router.push({name: p.name, direction: 'root'})">
                                <ion-label>{{ p.title }}</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                        <ion-menu-toggle auto-hide="false" menu="settings">
                            <ion-item button @click="testToast()">
                                <ion-label>Test Toast</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                        <ion-menu-toggle auto-hide="false" menu="settings">
                            <ion-item button @click="testZebraScanner()" :disabled="!$zebra.isReady">
                                <ion-label>Test Zebra Scanner</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                        <!--
                            18/Feb/2022 Removing because Michael reported lots of user
                            devices going into dark mode randomly - even system settings
                            can't turn it off
                        -->
                        <!--
                        <ion-menu-toggle auto-hide="false" menu="settings">
                            <ion-item>
                                <ion-label>Dark Mode</ion-label>
                                <ion-toggle @ion-change="toggleDarkMode($event.detail.checked)"></ion-toggle>
                            </ion-item>
                        </ion-menu-toggle>
                        -->
                        <ion-menu-toggle auto-hide="false" menu="settings">
                            <ion-item>
                                <ion-label>Hide Side Menus</ion-label>
                                <ion-toggle v-model="hideSideMenus"></ion-toggle>
                            </ion-item>
                        </ion-menu-toggle>
                        <ion-menu-toggle>
                            <ion-item>
                                <ion-label @click="checkForUpdates()">Check for Updates</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                        <ion-menu-toggle auto-hide="false" menu="settings">
                            <ion-item lines="none" button @click="logout()">
                                <ion-label slot="start">Logout</ion-label>
                            </ion-item>
                        </ion-menu-toggle>
                    </ion-list>
                </ion-content>
            </ion-menu>
            <ion-router-outlet id="main-content"></ion-router-outlet>
        </ion-split-pane>
    </ion-app>
</template>

<script>
import {IonApp, IonRouterOutlet} from '@ionic/vue';
import {IonListHeader, IonList, IonMenu, IonLabel, IonItem, IonMenuToggle, IonContent, IonSplitPane} from '@ionic/vue';
import {IonToggle, IonLoading} from '@ionic/vue';
import {menuController, alertController} from '@ionic/vue';
import {defineComponent} from 'vue';
import EventBus from './EventBus';
import Storage from './services/Storage';
import router from "@/router";
//import IonicDeploy from "@/services/IonicDeploy";
import { useBackButton } from '@ionic/vue';
export default {
    name: 'App',
    inject: ['$zebra', '$toast'],
    components: {
        IonLoading,
        IonApp,
        IonRouterOutlet,
        IonListHeader, IonLabel, IonItem, IonMenuToggle, IonContent, IonList, IonMenu, IonSplitPane,
        IonToggle
    },
    beforeCreate() {
        /*
        EventBus().emitter.on('loading', (loading) => {
            //this.busy = loading;
        });

         */
        EventBus().emitter.on('auth.logout', () => {
            this.user = null;
        });
        EventBus().emitter.on('auth.login', user => {
          this.user = user;
        });
    },
    mounted() {
        if (this.$zebra.isReady) {
          this.$toast.success("Zebra Integration Ready");
        }
        const storage = new Storage();
        storage.get('user').then(user => {
            this.user = user;
        });
    },
    methods: {
        checkForUpdate() {
            //this.$deploy.check();
        },
        logout() {

            // give us enough time to make sure user's cleared out
            // by sleeping for a few seconds, clear out the user
            // remove the Auth token from Axios...etc
            EventBus().emitter.emit('loading', true);
            new Storage().remove('user');
            EventBus().emitter.emit('auth.logout');
            if (menuController.isOpen()) {
                menuController.close();
            }
            setTimeout(() => {
                console.log("Broadcasting that we're logged out");
                EventBus().emitter.emit('loading', false);
                router.push({
                    name: 'login'
                });
            }, 500);
        },
        testToast() {
            this.$toast.success("Test Toast Message Successful!");
        },
        testZebraScanner() {
          console.log("Testing Zebra Scanner");
          this.$zebra.ping().then(zebra => {
            alertController.create({
              header: 'Zebra Integration',
              message: `Zebra Data Wedge v${zebra.response.DATAWEDGE}`,
              buttons: ['Ok']
            }).then(alert => alert.present());
          });
        },
        toggleZebraScanner(event) {

            event.preventDefault();
            event.stopImmediatePropagation();
            event.cancelBubble = true;
            event.stopPropagation();

            alertController.create({
                header: 'Not implemented',
                message: 'This feature has not yet been implemented',
                buttons: ['Ok']
            }).then(alert => alert.present());

            return false;

        },
        toggleDarkMode(dark) {
            if (dark) {
                document.body.classList.add('dark');
            } else {
                document.body.classList.remove('dark');
            }
        }
    },
    computed: {
        appPages() {
            if (! (this.user && this.user.id) ) {
                return [];
            }
            return [
                {
                    name: 'home',
                    title: 'Home'
                },
                {
                    name: 'stocktakes.mine',
                    title: 'My Stock Takes',
                    disabled: !this.user.permissions['warehouse.stocktake']
                },
                {
                    title: 'My Picks',
                    name: 'picks.mine',
                    disabled: !this.user.permissions['warehouse.pick']
                },
                {
                    title: 'My Packs',
                    name: 'packs.mine',
                    disabled: !this.user.permissions['warehouse.pack']
                },
                {
                    title: 'All Picks',
                    name: 'picks.all',
                    disabled: !this.user.permissions['warehouse.assign_users']
                },
                {
                    title: 'All Checks',
                    name: 'checks.all',
                    disabled: !this.user.permissions['warehouse.check']
                },
                {
                    title: 'All Packs',
                    name: 'packs.all'
                },
                {
                    title: 'All StockTakes',
                    name: 'stocktakes.all',
                    disabled: !this.user.permissions['warehouse.assign_users']
                },
                {
                    title: 'Goods In',
                    name: 'warehouse.receive.create',
                    disabled: !this.user.permissions['warehouse.receive']
                },
                {
                    title: 'Stacking List',
                    name: 'warehouse.stack.index',
                    disabled: !this.user.permissions['warehouse.stack']
                },
                {
                    title: 'Inventory',
                    name: 'warehouse.items.index',
                    disabled: !this.user.permissions['warehouse.stack']
                }
            ];
        }
    },
    data() {
        return {
            user: {},
            busy: false,
            hideSideMenus: false,
            dark: false,
            appSettingsPages: [{
                    name: 'test.scan',
                    title: 'Scan Test',
            }, {
                    name: 'test.camera',
                    title: 'Camera Test'
            }]
        }
    }
}
</script>
<style>
 .warehouse-qty-check ion-label {
     text-align: center;
 }
 .warehouse-qty-check ion-input {
     --padding-start: 0;
     font-size: 200%;
 }
 big-stepper ion-input {
     font-size: 200%;
 }
</style>
